export default "__VITE_ASSET__DVgv7Exn__"